import React from "react";
import './App.css';
import { getWindowParent } from 'lib/Utils';
import { isMobileDevice, MobileDeviceContext } from 'lib/Screen';
import 'bootstrap/dist/css/bootstrap.min.css';
import { HashRouter, Routes, Route, Link, Navigate } from "react-router-dom";

import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';

import Firstnames from 'components/Firstnames/Firstnames';
import Lastnames from 'components/Lastnames/Lastnames';
import Newborns from 'components/Newborns/Newborns';

import * as am4core from "@amcharts/amcharts4/core";

import translationsJson from 'data/translations.json';
import { AppBar, Collapse, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CloseIcon from '@mui/icons-material/Close';

const translations: Translations = translationsJson;

class App extends React.Component<{}, { mobileScreen: boolean, tabKey: string, menuOpen: boolean, }> {
    private defaultTabKey: string;
    private defaultSubTabKey: string;
    private resizeObserver: ResizeObserver | null;

    constructor(props: any) {
        super(props);

        const [tabKey, subTabKey] = this.parseLocation();

        this.defaultTabKey = tabKey;
        this.defaultSubTabKey = subTabKey;
        this.resizeObserver = null;

        //console.log("tabKey:", tabKey);
        //console.log("subTabKey:", subTabKey);

        this.state = {
            mobileScreen: isMobileDevice(),
            tabKey: tabKey,
            menuOpen: false
        };

        am4core.options.queue = true;
        //am4core.options.onlyShowOnViewport = true;
    }

    private parseLocation() {
        let tabKey = "newborns";
        let subTabKey = "wordcloud";
        const hash = window.location.hash;
        if (hash && hash.length) {
            const slashIndex = hash.indexOf('/', 2);
            if (slashIndex > -1) {
                tabKey = hash.substring(2, slashIndex);
                subTabKey = hash.substring(slashIndex + 1);
            } else {
                tabKey = hash.substring(2);
            }
        }

        return [tabKey, subTabKey];
    }

    private onMenuClick() {
        let tabKey = this.state.tabKey;
        if (!this.state.menuOpen && tabKey === "") {
            tabKey = this.parseLocation()[0];
        }
        this.setState({ menuOpen: !this.state.menuOpen, tabKey: tabKey });
    }

    private onMenuItemClick(panel: string) {
        if (this.state.tabKey === panel)
            this.setState({ tabKey: "" });
        else
            this.setState({ tabKey: panel });
    }

    private renderMobileNav() {
        const open = this.state.menuOpen;
        const [lcTabKey, locSubTabKey] = this.parseLocation();
        const [tabNewborns, tabFirstnames, tabLastnames] = [this.state.tabKey === "newborns", this.state.tabKey === "firstnames", this.state.tabKey === "lastnames"];
        const [locNewborns, locFirstnames, locLastnames] = [lcTabKey === "newborns", lcTabKey === "firstnames", lcTabKey === "lastnames"];
        const [wordcloud, ranking, graph, map, rankingGenerations, rankingMunicipality] = [
            locSubTabKey === "wordcloud",
            locSubTabKey === "ranking", 
            locSubTabKey === "graph",
            locSubTabKey === "map",
            locSubTabKey === "rankingGenerations",
            locSubTabKey === "rankingMunicipality"];

        return (
            <div>
                <AppBar position="static" elevation={0}>
                    <Toolbar className="navigation-toolbar">
                        <Typography variant="h5" sx={{ flexGrow: 1 }}>
                            {`${translations[lcTabKey][window.lang]} - ${translations[locSubTabKey][window.lang]}`}
                        </Typography>
                        <IconButton size="large" edge="end" aria-label="menu" onClick={() => this.onMenuClick()}>
                            {open ? <CloseIcon sx={{fontSize: "2.3rem"}} /> : <MenuIcon sx={{fontSize: "2.3rem"}} />}
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Collapse in={open} className="navigation-menu">
                    <List component="nav" sx={{ width: "100%" }}>
                        <ListItemButton className={lcTabKey === 'newborns' ? 'active-group' : ''} onClick={() => this.onMenuItemClick("newborns")}>
                            <ListItemText disableTypography primary={<Typography variant="h6">{translations.newborns[window.lang]}</Typography>} />
                            <ListItemIcon sx={{ minWidth: "20px" }}>
                                {tabNewborns ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </ListItemIcon>
                        </ListItemButton>
                        <Collapse in={tabNewborns}>
                            <List>
                                <Link className={`navigation-menu-link ${locNewborns && wordcloud ? 'active-link' : ''}`} to={"newborns/wordcloud"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.wordcloud[window.lang]}
                                    </ListItemButton>
                                </Link>

                                <Link className={`navigation-menu-link ${locNewborns && ranking ? 'active-link' : ''}`} to={"newborns/ranking"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.ranking[window.lang]}
                                    </ListItemButton>
                                </Link>

                                <Link className={`navigation-menu-link ${locNewborns && graph ? 'active-link' : ''}`} to={"newborns/graph"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.graph[window.lang]}
                                    </ListItemButton>
                                </Link>

                                <Link className={`navigation-menu-link ${locNewborns && rankingGenerations ? 'active-link' : ''}`} to={"newborns/rankingGenerations"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.rankingGenerations[window.lang]}
                                    </ListItemButton>
                                </Link>
                            </List>
                        </Collapse>

                        <ListItemButton className={lcTabKey === 'firstnames' ? 'active-group' : ''} onClick={() => this.onMenuItemClick("firstnames")}>
                            <ListItemText disableTypography primary={<Typography variant="h6">{translations.firstnames[window.lang]}</Typography>} />
                            <ListItemIcon sx={{ minWidth: "20px" }}>
                                {tabFirstnames ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </ListItemIcon>
                        </ListItemButton>
                        <Collapse in={tabFirstnames}>
                            <List>
                                <Link className={`navigation-menu-link ${locFirstnames && wordcloud ? 'active-link' : ''}`} to={"firstnames/wordcloud"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.wordcloud[window.lang]}
                                    </ListItemButton>
                                </Link>
                                <Link className={`navigation-menu-link ${locFirstnames && map ? 'active-link' : ''}`} to={"firstnames/map"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.map[window.lang]}
                                    </ListItemButton>
                                </Link>
                                <Link className={`navigation-menu-link ${locFirstnames && ranking ? 'active-link' : ''}`} to={"firstnames/ranking"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.ranking[window.lang]}
                                    </ListItemButton>
                                </Link>
                                <Link className={`navigation-menu-link ${locFirstnames && rankingMunicipality ? 'active-link' : ''}`} to={"firstnames/rankingMunicipality"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.rankingMunicipality[window.lang]}
                                    </ListItemButton>
                                </Link>
                            </List>
                        </Collapse>

                        <ListItemButton  className={lcTabKey === 'lastnames' ? 'active-group' : ''} onClick={() => this.onMenuItemClick("lastnames")}>
                            <ListItemText disableTypography primary={<Typography variant="h6">{translations.lastnames[window.lang]}</Typography>} />
                            <ListItemIcon sx={{ minWidth: "20px" }}>
                                {tabLastnames ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </ListItemIcon>
                        </ListItemButton>
                        <Collapse in={tabLastnames}>
                            <List>
                                <Link className={`navigation-menu-link ${locLastnames && wordcloud ? 'active-link' : ''}`} to={"lastnames/wordcloud"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.wordcloud[window.lang]}
                                    </ListItemButton>
                                </Link>
                                <Link className={`navigation-menu-link ${locLastnames &&map ? 'active-link' : ''}`} to={"lastnames/map"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.map[window.lang]}
                                    </ListItemButton>
                                </Link>
                                <Link className={`navigation-menu-link ${locLastnames &&ranking ? 'active-link' : ''}`} to={"lastnames/ranking"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.ranking[window.lang]}
                                    </ListItemButton>
                                </Link>
                                <Link className={`navigation-menu-link ${locLastnames &&rankingMunicipality ? 'active-link' : ''}`} to={"lastnames/rankingMunicipality"} onClick={() => this.onMenuClick()}>
                                    <ListItemButton sx={{ pl: 4 }}>
                                        {translations.rankingMunicipality[window.lang]}
                                    </ListItemButton>
                                </Link>
                            </List>
                        </Collapse>
                    </List>
                </Collapse>
                <Routes>
                    <Route path="/" element={<Navigate to="newborns" replace />} />
                    <Route path="newborns" element={<Newborns />}>
                        <Route path=":tab" element={<Newborns />} />
                    </Route>
                    <Route path="firstnames" element={<Firstnames />}>
                        <Route path=":tab" element={<Firstnames />} />
                    </Route>
                    <Route path="lastnames" element={<Lastnames />}>
                        <Route path=":tab" element={<Lastnames />} />
                    </Route>
                </Routes>
            </div>
        );
    }

    private renderDesktopNav() {
        return (
            <>
                <Tab.Container defaultActiveKey={this.defaultTabKey}>
                    <Nav className="main-nav">
                        <Nav.Item>
                            <Nav.Link eventKey="newborns" as={Link} to="newborns">{translations.newborns[window.lang]}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="firstnames" as={Link} to="firstnames">{translations.firstnames[window.lang]}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="lastnames" as={Link} to="lastnames">{translations.lastnames[window.lang]}</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Tab.Container>
                <Tab.Content className="main-nav-content">
                    <Routes>
                        <Route path="/" element={<Navigate to="newborns" replace />} />
                        <Route path="newborns" element={<Newborns />}>
                            <Route path=":tab" element={<Newborns />} />
                        </Route>
                        <Route path="firstnames" element={<Firstnames />}>
                            <Route path=":tab" element={<Firstnames />} />
                        </Route>
                        <Route path="lastnames" element={<Lastnames />}>
                            <Route path=":tab" element={<Lastnames />} />
                        </Route>
                    </Routes>
                </Tab.Content>
            </>
        );
    }

    componentDidMount() {
        window.addEventListener("load", ()=> {
            if (window.self === window.top) return; // if w.self === w.top, we are not in an iframe 
            const send_height_to_parent_function =  () => {
                var height = document.getElementsByTagName("html")[0].offsetHeight;
                console.log("Sending height as " + height + "px");
                const parent = getWindowParent();
                if (parent) {
                    parent.postMessage({ "height": height }, "*");
                }

                const isMobile = isMobileDevice();
                this.setState({
                    mobileScreen: isMobile
                });
            }
            // send message to parent about height updates
            send_height_to_parent_function(); //whenever the page is loaded
            window.addEventListener("resize", send_height_to_parent_function); // whenever the page is resized
            var observer = new MutationObserver(send_height_to_parent_function);           // whenever DOM changes PT1
            var config = { attributes: true, childList: true, characterData: true, subtree: true }; // PT2
            observer.observe(window.document, config);                                            // PT3 
        });
    }

    componentWillUnmount(): void {
        if(this.resizeObserver) {
            this.resizeObserver.unobserve(document.body);
            this.resizeObserver.disconnect();
        }
    }

    render() {
        return (
            <div id={process.env.NODE_ENV === 'development' ? "contentDev" : "contentProd"} className="main-content">
                <MobileDeviceContext.Provider value={this.state.mobileScreen}>
                    <HashRouter>
                        {this.state.mobileScreen ? this.renderMobileNav() : this.renderDesktopNav()}
                    </HashRouter>
                </MobileDeviceContext.Provider>
            </div>
        );
    }
}

export default App;
